import { MEDIA_NOW_PREFIX, MEDIA_NOW_SUFFIX } from './videoUrlComm';

export const ALLETRA5k_VIDEO_URL = Object.freeze({
  UNBOX: MEDIA_NOW_PREFIX + 'LONMSKHDGI&ek=2zw7wktc' + MEDIA_NOW_SUFFIX,
  RACK_STEP1: MEDIA_NOW_PREFIX + 'LNKOOMLKLL&ek=CLYm6cUS' + MEDIA_NOW_SUFFIX,
  RACK_STEP2: MEDIA_NOW_PREFIX + 'OOQRMSDMKE&ek=AN0bBBxc' + MEDIA_NOW_SUFFIX,
  RACK_STEP3: MEDIA_NOW_PREFIX + 'SLMONKELDM&ek=WyRvvYHM' + MEDIA_NOW_SUFFIX,
  CABLE: MEDIA_NOW_PREFIX + 'PNKNQMHIDG&ek=2oxwJYae' + MEDIA_NOW_SUFFIX,
  POWER: MEDIA_NOW_PREFIX + 'KORQOOMDEE&ek=I7LRQA3N' + MEDIA_NOW_SUFFIX,
  CONNECTARRAY: MEDIA_NOW_PREFIX + 'LRMPOSEKFF&ek=272I4fRG' + MEDIA_NOW_SUFFIX,
  SETUPARRAY: MEDIA_NOW_PREFIX + 'RJONMKIGJE&ek=FbOOJgao' + MEDIA_NOW_SUFFIX,
});
